import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    linkText: {
        cursor: 'pointer',
        color: theme.palette.primary.main,
        '&:hover': {
            textDecoration: 'underline'
        }
    }
});

const CopyLinkBase = ({ linkText, stringToCopy, copySuccessText, classes }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        try {
            navigator.clipboard.writeText(stringToCopy);
            setCopied(true);
        // eslint-disable-next-line no-unused-vars
        } catch (err) {
            setCopied(false);
        }
    };

    return (
        <Typography
            className={classes.linkText}
            component='span'
            onClick={handleCopy}>
            {copied ? copySuccessText : linkText}
        </Typography>
    );
};

CopyLinkBase.propTypes = {
    classes: PropTypes.object,
    linkText: PropTypes.string,
    copySuccessText: PropTypes.string,
    stringToCopy: PropTypes.string.isRequired
};

CopyLinkBase.defaultProps = {
    classes: {},
    linkText: 'copy',
    copySuccessText: 'copied!'
};

const CopyLink = withStyles(styles)(CopyLinkBase);

export default CopyLink;
